import React, { Component } from 'react';
import { Form } from 'react-form';
import Popup from '../../Popup';
import { Input, SchoolSearch } from '../../Form';
import { requiredEmail, required } from '../../../utils/validation';
import { SupportLink } from '../../Links';
import styles from './highSchoolSearchAndInvitePopup.scss';

class HighSchoolSearchAndInvitePopup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submitting: false,
            submitSuccessful: false,
            inviteError: false,
        };

        this.handleSchoolSelect = this.handleSchoolSelect.bind(this);
        this.handleClearSchoolClick = this.handleClearSchoolClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSchoolSelect(school, setValue) {
        setValue('schoolId', school.id);
    }

    handleClearSchoolClick(setValue) {
        setValue('schoolId', null);
    }

    async handleSubmit(values) {
        this.setState({
            submitting: true,
            submitSuccessful: false,
            inviteError: false,
        });

        try {
            await this.props.onCtaClickAsync(values);
            this.setState({
                submitting: false,
                submitSuccessful: true,
            });
        } catch (error) {
            this.setState({
                submitting: false,
                inviteError: true,
            });
        }
    }

    render() {
        const {
            currentSchoolId,
            onCloseClick,
            navigateAwayFromPage,
        } = this.props;

        const defaultValues = {
            schoolId: null,
            email: null,
        };

        return (
            <Popup
                className={`popup-md clear-over-flow`}
                popUpClassName={`${styles.highSchoolSearchAndInvitePopup}`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: false,
                    topGradient: false,
                    scrollable: false,
                }}
            >
                <div className={`${styles.section} pt0`}>
                    <h4>
                        {`Invite Coach to Activate High School`}
                    </h4>
                </div>
                <div className={`${styles.section} pt0`}>
                    <Form onSubmit={values => this.handleSubmit(values)} id="inviteCoachToClaimSchoolForm" defaultValues={defaultValues}>
                        {({ submitForm, values, errors, setValue }) => {
                            return (
                                <form onSubmit={submitForm} id="inviteCoachToClaimSchoolForm">
                                    {!this.state.submitSuccessful && (
                                        <React.Fragment>
                                            <div className="row mb16">
                                                <div className="col-12">
                                                    <div className="form-group form-group-xl">
                                                        <label>Opponent High School</label>
                                                        <SchoolSearch
                                                            placeholder={`Search for your opponent high school`}
                                                            handleSchoolSelect={(school) => this.handleSchoolSelect(school, setValue)}
                                                            clearAfterSelect={true}
                                                            closeAfterSelect={true}
                                                            displaySchoolNameAfterSelect={true}
                                                            showSearchClearIcon={true}
                                                            searchEndPoint="/highschools/claim"
                                                            // filter={`clubSubTypeId:${clubSubType.id}`}
                                                            schoolClubSearch={false}
                                                            entityId={currentSchoolId}
                                                            searchContainerClassName={styles.searchContainer}
                                                            handleClearSchoolClick={() => this.handleClearSchoolClick(setValue)}
                                                        />
                                                        <Input type="hidden" field={`schoolId`} validate={required} />
                                                        <div className={`d-block`}>
                                                            <small>If you are unable to find your high school, please contact our <SupportLink target="_blank">support team.</SupportLink></small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group form-group-xl">
                                                        <Input
                                                            label="Opponent Coach Email"
                                                            id="opponentCoachEmail"
                                                            field="email"
                                                            type="text"
                                                            placeholder="name@example.com"
                                                            validate={requiredEmail}
                                                            disableProfanityCheck={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {this.state.submitSuccessful && (
                                        <div className="row mb16">
                                            <div className="col-12">
                                                Thank you, an invitation has been sent to {values.email}.
                                            </div>
                                        </div>
                                    )}
                                    <hr />
                                    {errors && (
                                        <div className="pb24 text-center text-error text-small">Both school and coach email are required fields.</div>
                                    )}
                                    {this.state.inviteError && (
                                        <div className="pb24 text-center text-error text-small">
                                            An error occurred while inviting this coach to activate this school. If this problem persists, please contact our <SupportLink target="_blank">support team.</SupportLink>
                                        </div>
                                    )}
                                    {this.state.submitSuccessful && (
                                        <div className="row">
                                            <div className="col-12 mb16">
                                                <button
                                                    onClick={() => navigateAwayFromPage(true)}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                >
                                                    Got it
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {!this.state.submitSuccessful && (
                                        <div className="row">
                                            <div className="col-12 col-md-6 mb16">
                                                <button
                                                    onClick={onCloseClick}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    disabled={this.state.submitting}
                                                >
                                                    Invite
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </form>
                            );
                        }}
                    </Form>
                </div>
            </Popup>
        );
    }
}

export default HighSchoolSearchAndInvitePopup;
